import React, { Component } from 'react';

//componentes
import Referencia from './modificarRefe'

class Index extends Component {

    render(){
        return(
            <div>
                <Referencia />
            </div>
        );
    }

}
export default Index;